<template>
  <!-- 模板方案 -->
  <el-container class="banner-config-wrapper">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
    </div>
    <el-main>
      <!-- <div class="search-box">
        <div class="input-box">请输入手机号码</div>
        <span>免费开通</span>
      </div> -->
      <div class="relate-push-warapper">
        <div class="relate-box">
          <!-- 新增运营消息 -->
          <div class="relate-box-left">
            <h1 class="top_title"><span></span>运营消息</h1>
            <div class="">
              <el-form :model="formStepFirst" label-width="150px" size="mini" :rules="rulesFormFirst"
                ref="formStepFirst" label-position="right" class="edit">
                <el-form-item label="消息名称(用于管理):" prop="name">
                  <div class="label-item" v-if="this.type == 'see'">{{formStepFirst.name}}</div>
                  <div class="label-item" v-else>
                    <el-input placeholder="请输入消息名称" v-model.trim="formStepFirst.name" maxlength="20" show-word-limit style="max-width:320px;">
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item label="事件:" prop="titleTemplate">
                  <div style="display: flex;align-items:center">
                    <el-button type='primary' size='small' v-if="this.type != 'see'"
                      @click="choseListData">{{selectList.length > 0?'更改消息事件':'选择消息事件'}}
                    </el-button>
                    <div class="label-box">
                      <div style="display: flex;" v-for="(item, index) in selectList" :key="index">
                        <el-tag :title="item.msgEventName" :disable-transitions="false" style="margin-bottom: 5px;border-radius: 20px;" class="a-tag"
                          size="small" :closable="type != 'see'?true:false"
                          @close="delLabel(index)">{{ item.msgEventName}}</el-tag>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <div class="form-item" v-for="(item,index) in ruleList" :key="index"> 
                  <div class="form-item-top">
                    <p class="form-item-top-title">{{item.msgTemplateName}}</p>
                    <p class="form-item-top-text">{{item.templateDesc}}</p>
                  </div>
                  <div class="form-item-content">
                    <div class="form-item-content-center">
                      <el-form-item label="消息标题:">
                        <p class="label-item-back-title">{{item.templateTitle}}</p>
                      </el-form-item>
                      <el-form-item label="模板内容:" class="mb">
                        <div class="label-item-back" v-if="item.templateContent">
                          <p class="label-item-back-title">{{item.templateContent}}</p>
                        </div>
                      </el-form-item>
                      <el-form-item label="内容配置:" :required="true" >
                        <div class="label-item" :class="item.templateParam.length-1 == i?'':'mb20'" v-for="(el,i) in item.templateParam" :key="i">
                          <div>{ {{ el.key }} }</div>
                          <el-input type="textarea" placeholder="请输入参数内容" resize="none" v-model.trim="el.value"
                            maxlength="50" show-word-limit v-if="type != 'see'">
                          </el-input>
                          <div v-else>{{ el.value }}</div>
                        </div>
                        <!-- <div class="label-item mb20">
                          <div>{serviceName}</div>
                          <el-input type="textarea" placeholder="请输入参数内容" resize="none"
                            v-model.trim="formStepFirst.shareDesc" maxlength="50" show-word-limit v-if="type != 'see'">
                          </el-input>
                          <div v-else>{{ formStepFirst.shareDesc }}</div>
                        </div> -->
                      </el-form-item>
                    </div>
                    <!-- <div class="form-item-content-bottom">
                      <div class="form-item-channel">
                        <div class="form-item-channel-item">推送渠道：{{item.msgChannelName}}</div>
                        <div class="form-item-channel-item">发送周期：仅1次</div>
                        <div class="form-item-channel-item">发送时间：立即发送</div>
                      </div>
                      <a href="javascript:void(0);" @click="sendingRecordClick" class="sendingRecord">发送记录</a>
                    </div> -->
                    <div class="form-item-content-bottom">
                      <div class="form-item-channel mb15">
                        <div class="form-item-channel-item">推送渠道：{{item.msgChannelName}}</div>
                        <div class="form-item-channel-item">发送周期：{{pushCycleObj[item.pushCycle]}}</div>
                      </div>
                      <!-- pushTimeTypeObj pushCycleObj -->
                      <div class="form-item-channel">
                        <div class="form-item-channel-title">发送时间： </div>
                        <div class="form-item-channel-box">
                          <div class="form-item-channel-item mb20" v-for="(elTime,iTime) in item.pushTimeList"
                            :key="iTime">
                            <span
                              class="blue-icon" v-if="elTime.pushFirst == 1">首次触发</span>{{pushTimeTypeObj(elTime.pushTimeType)}}
                            <span v-if="elTime.pushTimeType == 2">延迟{{elTime.delayTime}}分钟</span><span
                              v-if="elTime.pushTimeType == 3">{{ elTime.timingTime }}</span><span
                              v-if="item.pushCycle == 'CUSTOM'"
                              class="yellow-icon">T+{{elTime.pushCustomCycle}}</span>
                          </div>
                          <!-- <div class="form-item-channel-item mb20"> <span class="blue-icon">首次触发</span>延迟发送 延迟3分钟 <span
                              class="yellow-icon">间隔区间</span>5天</div>
                          <div class="form-item-channel-item"> <span class="gray-icon">循环次数</span>循环上限5次 <span
                              class="gray-icon">循环发送</span>按首次发送时间</div> -->
                        </div>
                      </div>
                      <a href="javascript:void(0);" v-if="type == 'see'"
                        @click="sendingRecordClick(item.resPushEventRuleId)" class="sendingRecord">发送记录</a>
                    </div>
                  </div>
                </div>

                <!-- <div class="form-item" v-if="1">
                  <div class="form-item-top">
                    <p class="form-item-top-title">短信积分到账提醒</p>
                    <p class="form-item-top-text">这里是模版说明，用于某某用途</p>
                  </div>
                  <div class="form-item-content">
                    <div class="form-item-content-center">
                      <el-form-item label="模板内容:" class="mb">
                        <div class="label-item-back">
                          <p class="label-item-back-title">
                            恭喜！您获得了{"serviceName":"{serviceName}'}服务，点击{"serviceUrl":"{serviceUrl}"}下载激活吧~</p>
                        </div>
                      </el-form-item>
                      <el-form-item label="内容配置:" prop="shareDesc">
                        <div class="label-item mb20">
                          <div>{serviceName}</div>
                          <el-input type="textarea" placeholder="请输入参数内容" resize="none"
                            v-model.trim="formStepFirst.shareDesc" maxlength="50" show-word-limit v-if="type != 'see'">
                          </el-input>
                          <div v-else>{{ formStepFirst.shareDesc }}</div>
                        </div>
                        <div class="label-item mb20">
                          <div>{serviceName}</div>
                          <el-input type="textarea" placeholder="请输入参数内容" resize="none"
                            v-model.trim="formStepFirst.shareDesc" maxlength="50" show-word-limit v-if="type != 'see'">
                          </el-input>
                          <div v-else>{{ formStepFirst.shareDesc }}</div>
                        </div>
                      </el-form-item>
                    </div>
                    <div class="form-item-content-bottom">
                      <div class="form-item-channel">
                        <div class="form-item-channel-item">推送渠道：阿里云短信</div>
                        <div class="form-item-channel-item">发送周期：仅1次</div>
                        <div class="form-item-channel-item">发送时间：立即发送</div>
                      </div>
                      <a href="javascript:void(0);" @click="sendingRecordClick" class="sendingRecord">发送记录</a>
                    </div>
                  </div>
                </div>
                <div class="form-item" v-if="1">
                  <div class="form-item-top">
                    <p class="form-item-top-title">积分到账提醒</p>
                    <p class="form-item-top-text">这里是模版说明，用于某某用途</p>
                  </div>
                  <div class="form-item-content">
                    <div class="form-item-content-center">
                      <el-form-item label="消息标题:">
                        <p class="label-item-back-title">打卡提醒</p>
                      </el-form-item>
                      <el-form-item label="模板内容:" class="mb">
                        <div class="label-item-back">
                          <p class="label-item-back-title">事件名称 'thing4.DATA'</p>
                          <p class="label-item-back-title">积分值 time5.DATA</p>
                        </div>
                      </el-form-item>
                      <el-form-item label="内容配置:" prop="shareDesc">
                        <div class="label-item mb20">
                          <div>{serviceName}</div>
                          <el-input type="textarea" placeholder="请输入参数内容" resize="none"
                            v-model.trim="formStepFirst.shareDesc" maxlength="50" show-word-limit v-if="type != 'see'">
                          </el-input>
                          <div v-else>{{ formStepFirst.shareDesc }}</div>
                        </div>
                        <div class="label-item mb20">
                          <div>{serviceName}</div>
                          <el-input type="textarea" placeholder="请输入参数内容" resize="none"
                            v-model.trim="formStepFirst.shareDesc" maxlength="50" show-word-limit>
                          </el-input>
                        </div>
                      </el-form-item>
                    </div>
                    <div class="form-item-content-bottom">
                      <div class="form-item-channel mb20">
                        <div class="form-item-channel-item">推送渠道：阿里云短信</div>
                        <div class="form-item-channel-item">发送周期：仅1次</div>
                        <div class="form-item-channel-item">发送时间：立即发送</div>
                      </div>
                      <div class="form-item-channel">
                        <div class="form-item-channel-title">发送时间： </div>
                        <div class="form-item-channel-box">
                          <div class="form-item-channel-item"> <span class="blue-icon">首次触发</span>定时发送 15:30 <span
                              class="yellow-icon">T+3</span>按首次发送时间 延迟5分钟</div>
                        </div>
                      </div>
                      <a href="javascript:void(0);" @click="sendingRecordClick" class="sendingRecord">发送记录</a>
                    </div>
                  </div>
                </div>
                <div class="form-item" v-if="1">
                  <div class="form-item-top">
                    <p class="form-item-top-title">优惠接单通知</p>
                    <p class="form-item-top-text">这里是模版说明，用于某某用途</p>
                  </div>
                  <div class="form-item-content">
                    <div class="form-item-content-center">
                      <el-form-item label="消息标题:">
                        <p class="label-item-back-title">问诊订单双倍返积分啦</p>
                      </el-form-item>
                      <el-form-item label="模板内容:" class="mb">
                        <div class="label-item-back">
                          <p class="label-item-back-title">事件名称 'thing4.DATA'</p>
                        </div>
                      </el-form-item>
                      <el-form-item label="内容配置:" prop="shareDesc">
                        <div class="label-item mb20">
                          <div>{serviceName}</div>
                          <el-input type="textarea" placeholder="请输入参数内容" resize="none"
                            v-model.trim="formStepFirst.shareDesc" maxlength="50" show-word-limit v-if="type != 'see'">
                          </el-input>
                          <div v-else>{{ formStepFirst.shareDesc }}</div>
                        </div>
                      </el-form-item>
                    </div>
                    <div class="form-item-content-bottom">
                      <div class="form-item-channel mb20">
                        <div class="form-item-channel-item">推送渠道：医生端push</div>
                        <div class="form-item-channel-item">发送周期：循环周期</div>
                      </div>
                      <div class="form-item-channel">
                        <div class="form-item-channel-title">发送时间： </div>
                        <div class="form-item-channel-box">
                          <div class="form-item-channel-item mb20"> <span class="blue-icon">首次触发</span>延迟发送 延迟3分钟 <span
                              class="yellow-icon">间隔区间</span>5天</div>
                          <div class="form-item-channel-item"> <span class="gray-icon">循环次数</span>循环上限5次 <span
                              class="gray-icon">循环发送</span>按首次发送时间</div>
                        </div>
                      </div>
                      <a href="javascript:void(0);" @click="sendingRecordClick" class="sendingRecord">发送记录</a>
                    </div>
                  </div>
                </div> -->
                <el-form-item label="目标用户:" prop="scope">
                  <div class="label-item">
                    <el-radio-group v-model="formStepFirst.scope" :disabled="type != 'see'?false:true"
                      @change="scopeApplicationChange">
                      <el-radio label="set_patient_label">标签集合-患者</el-radio>
                      <el-radio label="set_user_patient">用户集合-患者</el-radio>
                      <el-radio label="set_user_doctor">用户集合-医生</el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <el-form-item label=" " class="mb" v-if="assembleList.length > 0">
                  <div class="label-box">
                    <div style="display: flex;" v-for="(item, index) in assembleList" :key="index">
                      <el-tag :title="item.title" style="margin-bottom: 5px;border-radius: 20px;" class="a-tag"
                        size="small" :closable="type != 'see'?true:false"
                        @close="delAssemble(index,item)">{{ item.name}}</el-tag>
                    </div>
                  </div>
                </el-form-item>
                <!-- <el-form-item label=" " class="mb"
                  v-if="type != 'see' && assembleList.length == 0 && formStepFirst.scope"> -->
                <el-form-item label=" " class="mb" v-if="type != 'see' && assembleList.length == 0 && formStepFirst.scope">
                  <div class="addIndexValue" @click="addIndexValueQuantitativemClick"> + 添加用户集合</div>
                </el-form-item>
                <el-form-item label=" " class="mb" v-if="type != 'see' && assembleList.length > 0 && formStepFirst.scope">
                  <div class="addIndexValue" @click="addIndexValueQuantitativemClick"> + 更换用户集合</div>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer" v-if="type != 'see'">
                <el-button @click="cancelSubmit">重置</el-button>
                <el-button type="primary" size="medium" @click="confirmSubmit('formStepFirst')">提交</el-button>
              </div>
              <div class="tip-box" v-if="selectList.length > 0 && type != 'see'">
                <img src="../../../assets/images/tip-gray-icon.png" alt="">
                <span>提交后默认为禁用状态，需点击【激活】进行激活</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <!-- 用户集合弹窗 -->
    <el-dialog :visible.sync="showAddQuestionShop" :close-on-click-modal="false" width="800px"
      :before-close="handleCloseShop" title="添加用户集合">
      <div class="dialog-main-content" v-if="scopeName == 'set_patient_label'">
        <div class="search-box">
          <el-input placeholder="请输入集合名称" v-model.trim="searchParamsGroup.name" maxlength="20"></el-input>
          <el-button @click="resetClickShopUser" size="small">重置</el-button>
          <el-button type="primary" @click="searchClickShopUser" size="small">搜索</el-button>
        </div>
        <div>
          <div class="main-content-list" style="max-height:380px;overflow:auto;">
            <el-table :data="tableDataShopUser" style="width: 100%;" :header-cell-style="{
                background: '#FAFAFA',
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px'
              }">
              <!-- <el-table-column prop="index" label="序号" align="center" show-overflow-tooltip>
              </el-table-column> -->
              <el-table-column prop="name" label="集合名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="describe" label="集合说明" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100px">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.flag" @click.native.prevent="
                      assessmentSendShopUser(scope.$index, scope.row)
                    " type="text" size="small">
                    选用
                  </el-button>
                  <el-button v-else style="color: #CCCCCC;" type="text" size="small">
                    已选
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
            <el-pagination background :current-page="searchParamsGroup.current" :page-sizes="[10, 20, 30, 50]"
              :page-size="searchParamsGroup.size" layout="total, sizes, prev, pager, next, jumper"
              :total="totalShopUser" @size-change="handleSizeChangeShopUser"
              @current-change="handleCurrentChangeShopUser" />
          </div>
        </div>
      </div>
      <div class="dialog-main-content" v-if="scopeName == 'set_user_patient' || scopeName == 'set_user_doctor'"> 
        <div class="search-box">
          <el-input placeholder="请输入集合名称" v-model.trim="listQueryShop.name" maxlength="20"></el-input>
          <el-button @click="resetClickShop" size="small">重置</el-button>
          <el-button type="primary" @click="searchClickShop" size="small">搜索</el-button>
        </div>
        <div>
          <div class="main-content-list" style="max-height:380px;overflow:auto;">
            <el-table :data="tableDataShop" style="width: 100%;" :header-cell-style="{
                background: '#FAFAFA',
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px'
              }">
              <!-- <el-table-column prop="index" label="序号" align="center" show-overflow-tooltip>
              </el-table-column> -->
              <el-table-column prop="name" label="集合名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="describe" label="集合说明" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.flag" @click.native.prevent="
                      assessmentSendShop(scope.$index, scope.row)
                    " type="text" size="small">
                    选用
                  </el-button>
                  <el-button v-else style="color: #CCCCCC;" type="text" size="small">
                    已选
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
            <el-pagination background :current-page="listQueryShop.current" :page-sizes="[10, 20, 30, 50]"
              :page-size="listQueryShop.size" layout="total, sizes, prev, pager, next, jumper" :total="totalShop"
              @size-change="handleSizeChangeShop" @current-change="handleCurrentChangeShop" />
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="选择消息事件" :visible.sync="showContentDialog" width="800px" :modal-append-to-body="true"
      :append-to-body="true" :before-close="handleClose">
      <div class="relate-push-warapper">
        <!-- 消息模板 -->
        <!-- <h1 class="top_title"><span></span>消息模板</h1> -->
        <div class="dialog-right-content">
          <div class="search-box">
            <!-- <div class="search-box-left"> -->
            <el-input placeholder="请输入事件名称/事件说明/事件编码" v-model.trim="listQueryTemplate.search" maxlength="20"
              size="small"></el-input>
            <!-- <el-select v-model="listQueryTemplate.send" size="small" value-key="send" placeholder="请选择发送状态"
                  @change="sendChange">
                  <el-option v-for="item in sendList" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select> -->
            <!-- </div> -->
            <!-- <div class="search-box-right"> -->
            <el-button @click="resetClickTemplate" size="small">重置</el-button>
            <el-button type="primary" @click="searchClickTemplate" size="small">搜索</el-button>
            <!-- </div> -->

          </div>
          <div>
            <div class="main-content-list">
              <el-table :data="tableDataTemplate" border style="width: 100%;" :header-cell-style="{
                background: '#FAFAFA',
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px'
              }">
                <el-table-column prop="msgEventCode" label="事件编码" align="center"
                  show-overflow-tooltip></el-table-column>
                <el-table-column prop="msgEventName" label="事件名称" align="center"
                  show-overflow-tooltip></el-table-column>
                <el-table-column prop="msgEventDesc" label="事件说明" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="templateChannelList" label="模版" align="center" class-name="nameClass">
                  <template slot-scope="scope">
                    <div class="merge-box">
                      <div class="merge-box-item" v-for="(item,index) in scope.row.templateChannelList" :key="index"
                        :title="item.templateName">
                        {{item.templateName}}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="templateChannelList" label="推送渠道" align="center" class-name="nameClass">
                  <template slot-scope="scope">
                    <!-- <div class="send-box">
                      <span class="send-icon-one">阿里云短信</span>
                    </div> -->
                    <div class="merge-box">
                      <div class="merge-box-item" v-for="(item,index) in scope.row.templateChannelList" :key="index"
                        :title="item.channelName">
                        {{item.channelName}}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.flag" :disabled="scope.row.msgEventState == 2"
                      @click.native.prevent="assessmentSendTemplate(scope.$index, scope.row)" type="text" size="small">
                      选用
                    </el-button>
                    <el-button v-else style="color: #CCCCCC;" type="text" size="small">
                      已选
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页 -->
            <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
              <el-pagination background :current-page="listQueryTemplate.current" :page-sizes="[10, 20, 30, 50]"
                :page-size="listQueryTemplate.size" layout="total, sizes, prev, pager, next, jumper"
                :total="totalTemplate" @size-change="handleSizeChangeTemplate"
                @current-change="handleCurrentChangeTemplate" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 发送记录 -->
    <el-dialog :visible.sync="showAddQuestionRecord" :close-on-click-modal="false" width="800px"
      :before-close="handleCloseRecord" title="发送记录">
      <div class="dialog-main-content">
        <div class="record-content">
          <div class="record-content-one">
            <div class="dialog-main-content">
              <div class="search-box">
                <div class="search-box-left">
                  <!-- <el-input placeholder="请输入姓名或手机号" v-model.trim="listQueryShop.goodsName" maxlength="20"
                  size="small"></el-input> -->
                  <el-date-picker v-model="pushBeginTimeList" value-format="yyyy-MM-dd" :default-time="['00:00:00']"
                    clearable align="center" popper-class="popper-class" type="daterange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" @change="changeOrderTime">
                  </el-date-picker>
                  <el-select v-model="listQueryRecord.pushRecordState" size="small" value-key="send"
                    placeholder="请选择发送状态" @change="sendChange" style="width:300px;">
                    <el-option v-for="item in sendList" :key="item.value" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="search-box-right">
                  <el-button @click="resetClickRecord" size="small">重置</el-button>
                  <el-button type="primary" @click="searchClickRecord" size="small">搜索</el-button>
                </div>
              </div>
              <div class="title-box">
                <div class="title-box-right">
                  
                  <div class="user-box-item" v-for="(item,index) in countList" :key="index"><span class="user-box-item-title">{{pushRecordStateObj(item.pushRecordState)}}：</span><span
                      class="user-box-item-text">{{ item.count }}</span></div>

                  <!-- <div class="user-box-item"><span class="user-box-item-title">可发送：</span><span
                      class="user-box-item-text">213</span></div>
                  <div class="user-box-item"><span class="user-box-item-title">发送：</span><span
                      class="user-box-item-text">200</span></div>
                  <div class="user-box-item"><span class="user-box-item-title">送达：</span><span
                      class="user-box-item-text">26</span></div>
                  <div class="user-box-item"><span class="user-box-item-title">展示：</span><span
                      class="user-box-item-text">26</span></div>
                  <div class="user-box-item"><span class="user-box-item-title">点击：</span><span
                      class="user-box-item-text">26</span></div> -->
                </div>
              </div>
              <div>
                <div class="main-content-list" style="height:340px;overflow:auto;">
                  <el-table :data="tableDataRecord" style="width: 100%;" :header-cell-style="{
                background: '#FAFAFA',
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px'
              }">
                    <el-table-column prop="pushTime" label="发送时间" align="center"
                      show-overflow-tooltip></el-table-column>
                    <el-table-column prop="id" label="ID" align="center" show-overflow-tooltip></el-table-column>
                    <!-- <el-table-column prop="pushTargetName" label="姓名" align="center" show-overflow-tooltip></el-table-column> -->
                    <el-table-column prop="pushTargetAccount" label="目标用户标识" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="pushRecordState" label="发送状态" align="center">
                      <template slot-scope="scope">
                        <div class="send-box">
                          <span class="send-icon-one" v-if="scope.row.pushRecordState == 0">待发送</span>
                          <span class="send-icon-two" v-if="scope.row.pushRecordState == 1">已发送</span>
                          <!-- <span class="send-icon-three" v-if="scope.row.pushRecordState == 1">发送中</span> -->
                          <span class="send-icon-four" v-if="scope.row.pushRecordState == 2">发送失败</span>
                          <span class="send-icon-four" v-if="scope.row.pushRecordState == 3">黑名单</span>
                          <span class="send-icon-three" v-if="scope.row.pushRecordState == 5">用户已读</span>
                        </div>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="contactTime" label="触达时间" align="center" show-overflow-tooltip>
                    </el-table-column> -->
                  </el-table>
                </div>
                <!-- 分页 -->
                <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
                  <el-pagination background :current-page="listQueryRecord.current" :page-sizes="[10, 20, 30, 50]"
                    :page-size="listQueryRecord.size" layout="total, sizes, prev, pager, next, jumper"
                    :total="totalRecord" @size-change="handleSizeChangeRecord"
                    @current-change="handleCurrentChangeRecord" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>
  
<script>
import {
  pageOperateList,
  operationalAdd,
  operationalEdit,
  eventDetail,
  operationalDetail,
  recordPage,
  recordCount
} from "@/api/operationalMessage";
import { groupList } from "@/api/Patientmanagement.js";
import { pageUserList } from "@/api/userSet.js";

export default {
  data() {
    return {
      breadList: [{ name: "运营管理" }, { name: "新增运营消息" }],
      searchParams: {
        current: 1,
        size: 10
      },
      total: 0, //总条数
      tableData: [],
      type: null,
      id: null,
      showAddQuestionShop: false, //添加用户集合弹窗
      listQueryShop: {
        //商品搜索条件
        //弹窗
        current: 1,
        size: 10,
        goodsName: null,
        type: null
      },
      tableDataShop: [], //添加集合数组
      showContentDialog: false,
      formStepFirst: {
        //表单value值
        name: "", //名称
        titleTemplate: "", //
        time: "", //标题
        belong: 0, //归属
        hospitalId: "", //机构id
        doctorTeamId: "", //团队id
        diseaseId: "", //病种id
        scope: null //应用范围
      },
      rulesFormFirst: {
        //验证表单
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        time: [{ required: true, message: "请选择发送时间", trigger: "blur" }],
        titleTemplate: [
          { required: true, message: "请选择事件", trigger: "click" }
        ],
        shareDesc: [
          { required: true, message: "请选择发送时间", trigger: "blur" }
        ],
        scope: [
          { required: true, message: "请选择目标用户", trigger: "change" }
        ]
      },
      selectList: [], //选中的模板
      totalShop: 0,
      serviceUrl: null,
      serviceName: null,
      listQueryTemplate: {
        //商品搜索条件
        //弹窗
        current: 1,
        size: 10,
        search: null,
      },
      tableDataTemplate: [], //添加集合数组
      sendList: [
        {
          name: "待发送",
          value: "0"
        },
        {
          name: "已发送",
          value: "1"
        },
        {
          name: "发送失败",
          value: "2"
        },
        {
          name: "黑名单",
          value: "3"
        },
        {
          name: "用户已读",
          value: "5"
        }
      ], //数组
      assembleList: [], //数组
      tableDataRecord: [], //发送记录
      showAddQuestionRecord: false,
      listQueryRecord: {
        //商品搜索条件
        //弹窗
        current: 1,
        size: 10,
        msgEventId: null, //事件id
        msgTemplateId: null, //模板id
        pushRuleId: null, //推送事件规则IDx
        pushBeginTime: null, //开始时间
        pushEndTime: null, //结束时间
        pushRecordState: null //消息推送状态
      },
      totalTemplate: 0,
      detailSaveDtos: [], //事件详情
      ruleList: [], //消息事件详情返回的列表
      pushCycleObj: {
        ONLY_ONE: "仅一次",
        CUSTOM: "自定义周期",
        CYCLE: "循环周期"
      },
      detailVosList: [],
      totalRecord: 0,
      pushBeginTimeList: [],
      searchParamsGroup: {
        //标签集合
        current: 1,
        size: 10,
        name: null,
        recordStatus:1,
      },
      scopeName: null,
      totalShopUser: 0,
      tableDataShopUser: [],
      countList:[],//发送记录弹窗数字统计
    };
  },
  created() {
    // this.pageListrequest();
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.operationalDetailRequest();
    }

    this.tableDataTemplateRequest(); //选择事件模板
    this.tableDataShopRequest(); //用户集合
  },
  mounted() {
    // this.getSpanArr(this.tableData);
  },
  filters: {
    //文字长度过滤
    ellipsis(value) {
      if (!value) {
        return;
      }
      if (value.length > 8) {
        return value.slice(0, 8) + "...";
      } else {
        return value;
      }
    }
  },
  methods: {
    pushTimeTypeObj(value) {
      let name = "";
      if (value == 1) {
        name = "立即发送";
      } else if (value == 2) {
        name = "延迟发送";
      } else if (value == 3) {
        name = "定时发送";
      } else if (value == 4) {
        name = "按照首次发送时间";
      } else if (value == 5) {
        name = "按照首次发送时间延迟";
      }
      return name
    },
    pushRecordStateObj(value) {
      let name = "";
      if (value == 0) {
        name = "待发送";
      } else if (value == 1) {
        name = "发送成功";
      } else if (value == 2) {
        name = "发送失败";
      } else if (value == 3) {
        name = "黑名单";
      } else if (value == 5) {
        name = "用户已读";
      }
      return name
    },
    pageListrequest() {
      pageList(this.searchParams).then(res => {
        if (res.code == 0) {
          if (res.data) {
            if (res.data.records && res.data.records.length > 0) {
              this.tableData = res.data.records.map(item => {
                return {
                  ...item,
                  pictureUri: this.imgPath + item.pictureUri
                };
              });
              this.total = res.data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      });
    },
    shopPageRequest() {},
    handleCloseShop() {
      //添加集合弹窗关闭
      this.showAddQuestionShop = false;
      // this.showContentDialog = true;
    },
    handleClose() {
      //运营消息弹窗关闭
      this.showContentDialog = false;
    },
    resetClickShop() {
      //弹窗集合服务重置
      this.listQueryShop.size = 10;
      this.listQueryShop.current = 1;
      this.listQueryShop.name = null;
      this.tableDataShopRequest();
    },
    searchClickShop() {
      //弹窗集合服务搜索
      this.listQueryShop.size = 10;
      this.listQueryShop.current = 1;
      this.tableDataShopRequest();
    },
    resetClickShopUser() {
      //弹窗集合服务重置
      this.searchParamsGroup.size = 10;
      this.searchParamsGroup.current = 1;
      this.searchParamsGroup.name = null;
      this.groupListRequest();
    },
    searchClickShopUser() {
      //弹窗集合服务搜索
      this.searchParamsGroup.size = 10;
      this.searchParamsGroup.current = 1;
      this.groupListRequest();
    },
    assessmentSendShop(index, row) {
      //选择集合
      this.tableDataShop[index].flag = false;
      // this.assembleList.push(row);
      this.assembleList[0] = row;
      console.log(this.assembleList[0],'this.assembleList[0]');
      this.showAddQuestionShop = false;
    },
    assessmentSendShopUser(index, row) {
      //选择集合
      this.tableDataShopUser[index].flag = false;
      // this.assembleList.push(row);
      this.assembleList[0] = row;
      console.log(this.assembleList[0],'this.assembleList[0]');
      this.showAddQuestionShop = false;
    },
    handleSizeChangeShop(val) {
      //添加集合分页
      this.listQueryShop.size = val;
      this.listQueryShop.current = 1;
      this.tableDataShopRequest();
    },
    handleCurrentChangeShop(val) {
      //添加集合分页
      this.listQueryShop.current = val;
      this.tableDataShopRequest();
    },
    handleSizeChangeShopUser(val) {
      //添加集合分页
      this.searchParamsGroup.size = val;
      this.searchParamsGroup.current = 1;
      this.groupListRequest();
    },
    handleCurrentChangeShopUser(val) {
      //添加集合分页
      console.log(val, "val");
      this.searchParamsGroup.current = val;
      this.groupListRequest();
    },
    handleCloseRecord() {
      this.showAddQuestionRecord = false;
    },
    choseListData() {
      //更改模板按钮
      this.showContentDialog = true;
      this.listQueryTemplate.size = 10;
      this.listQueryTemplate.current = 1;
      this.tableDataTemplateRequest();
    },
    delLabel(index) {
      //删除的选中的模板
      this.selectList.splice(index, 1);
      if (this.selectList.length == 0) {
        this.formStepFirst.titleTemplate = null;
        this.ruleList = [];
      }
    },
    delAssemble(index, item) {
      //删除的选中的模板
      this.assembleList.splice(index, 1);
    },
    cancelSubmit() {//重置
      
      this.formStepFirst.name = null;
      this.formStepFirst.titleTemplate = null;
      this.formStepFirst.scope = null;
      this.selectList = [];
      this.ruleList = [];
      this.assembleList = [];

        
    },
    confirmSubmit(formName) {
      console.log(this.selectList,'this.selectList');
      this.$refs[formName].validate(valid => {
        if (valid) {
          let detailSaveDtosList = [];
          let paramsObj = {
            templateName: "",
            channelName: "",
            msgEventRuleId: "",
            msgChannelId: "",
            params: ""
          };
          let flag = false;
          if (this.ruleList.length > 0) {
            this.ruleList.forEach((item, index) => {
              console.log(item.templateParam, "templateParam");
              let templateParamList = [];

              if (item.templateParam && item.templateParam.length > 0) {
                templateParamList = item.templateParam.map((el, i) => {
                  return {
                    key: el.key,
                    value: el.value
                  };
                });
                item.templateParam.forEach((el, i) => {
                  if (el.value == "") {
                    flag = true;
                  }
                });
              } else {
                templateParamList = [];
              }
              paramsObj = {
                templateName: item.msgTemplateName,
                channelName: item.msgChannelName,
                msgEventRuleCode: item.msgEventRuleCode,
                msgChannelId: item.msgChannelId,
                params: JSON.stringify(templateParamList)
              };
              detailSaveDtosList.push(paramsObj);
            });
          }
          if (flag) {
            this.$message.error("请填写相关内容配置");
            return false;
          }
          if (this.assembleList.length <= 0) {
            this.$message.error("请选择用户集合");
            return false;
          }
          let obj = {
            name: this.formStepFirst.name,
            eventName:
              this.selectList.length > 0
                ? this.selectList[0].msgEventName
                : null,
            eventId: this.selectList.length > 0 ? this.selectList[0].id : null,
            msgEventCode:this.selectList.length > 0 ? this.selectList[0].msgEventCode : null,
            targetUsersType: this.formStepFirst.scope,
            targetUsersId:
              this.assembleList.length > 0 ? this.assembleList[0].id : null,
            detailSaveDtos: detailSaveDtosList
          };

          console.log(obj, "obj");
          // return false;
          if (this.type == "add") {
            //新增
            operationalAdd(obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success("新增成功");
                  this.$router.push({
                    path: "/termPage/operationalMessage"
                  });
                }
              })
              .catch(res => {
                this.$message.error(res.message);
              });
          } else if (this.type == "edit") {
            //编辑
            obj.id = this.id;
            obj.detailUpdateDtos = obj.detailSaveDtos;

            this.detailVosList.forEach((item, index) => {
              obj.detailUpdateDtos[index].id = item.id;
            });
            delete obj.detailSaveDtos;
            operationalEdit(obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success("编辑成功");
                  this.$router.push({
                    path: "/termPage/operationalMessage"
                  });
                }
              })
              .catch(res => {
                this.$message.error(res.message);
              });
          }
        } else {
          return false;
        }
      });
    },
    scopeApplicationChange(value) {
      console.log(value, "wewe");
      this.scopeName = value;
      this.assembleList = [];
      this.tableDataShopUser = [];
      this.tableDataShop = [];
       
      // if (value == "set_patient_label") {
      //   //标签集合
      // } else if (value == "set_user_patient") {
      //   //用户集合-患者
      //   this.listQueryShop.type = 'patient'
      // } else if (value == "set_user_doctor") {
      //   //用户集合-医生
      //   this.listQueryShop.type = 'doctor'
      // }
    },
    scopeTimeChange(value) {},
    addIndexValueQuantitativemClick() {
      this.showAddQuestionShop = true;
      this.searchParamsGroup.current = 1;
      this.searchParamsGroup.name = null;
      this.listQueryShop.current = 1;
      this.listQueryShop.name = null;
      if (this.scopeName == "set_patient_label") {
        //标签集合
        this.groupListRequest();
      } else if (this.scopeName == "set_user_patient") {
        //用户集合-患者
        this.listQueryShop.type = "patient";
        this.tableDataShopRequest();
      } else if (this.scopeName == "set_user_doctor") {
        //用户集合-医生
        this.listQueryShop.type = "doctor";
        this.tableDataShopRequest();
      }
    },
    assessmentSendTemplate(index, item) {
      //选用模板
      this.detailSaveDtos = [];
      this.ruleList = [];
      this.tableDataTemplate[index].flag = false;
      this.selectList[0] = item;
      // this.listQueryRecord.msgEventId = item.id;
      this.formStepFirst.titleTemplate = item.msgEventName;
      this.$refs["formStepFirst"].clearValidate("titleTemplate");
      this.showContentDialog = false;

      this.eventDetailRequest();
    },
    eventDetailRequest() {
      //事件详情
      return new Promise((resolve, reject) => {
        eventDetail({
          id: this.selectList[0].id
        })
          .then(res => {
            if (res.code == 0) {
              if (res.data) {
                if (res.data.ruleList && res.data.ruleList.length > 0) {
                  res.data.ruleList.forEach((item, index) => {
                    if (item.templateParam) {
                      let templateParamList = JSON.parse(item.templateParam);
                      templateParamList.forEach((tempItem,tempIndex) => {
                        tempItem.value = '';
                      })
                      item.templateParam = templateParamList
                    }
                  });
                  this.ruleList = res.data.ruleList;
                  console.log(this.ruleList, "this.ruleList");
                } else {
                  this.ruleList = [];
                }
                resolve(res.data);
              } else {
                this.ruleList = [];
              }
            } else {
              this.ruleList = [];
            }
          })
          .catch(res => {
            reject(res);
            this.ruleList = [];
          });
      });
    },

    handleSizeChangeTemplate(val) {
      //添加集合分页
      this.listQueryTemplate.size = val;
      this.listQueryTemplate.current = 1;
      this.tableDataTemplateRequest();
    },

    handleCurrentChangeTemplate(val) {
      //添加集合分页
      this.listQueryTemplate.current = val;
      this.tableDataTemplateRequest();
    },
    resetClickTemplate() {
      //弹窗集合服务重置
      this.listQueryTemplate.size = 10;
      this.listQueryTemplate.current = 1;
      this.listQueryTemplate.search = null;
      this.tableDataTemplateRequest();
    },
    searchClickTemplate() {
      //弹窗集合服务搜索
      this.listQueryTemplate.size = 10;
      this.listQueryTemplate.current = 1;
      this.tableDataTemplateRequest();
    },
    sendChange() {},
    changeOrderTime() {
      //订单查询时间
      console.log(this.pushBeginTimeList, "this.pushBeginTimeList");
      let timeBegin = this.pushBeginTimeList[0].toString().substring(0, 10);
      let timeEnd = this.pushBeginTimeList[1].toString().substring(0, 10);
      this.listQueryRecord.pushBeginTime = timeBegin + ' ' + '00:00:00';
      this.listQueryRecord.pushEndTime = timeEnd + ' ' +'23:59:59';
      console.log(timeBegin, "timeBegin");
      console.log(timeEnd, "timeEnd");
      console.log(this.listQueryRecord, "this.listQueryRecord");
    },
    resetClickRecord() {
      //弹窗集合服务重置
      this.pushBeginTimeList = [];
      this.listQueryRecord.size = 10;
      this.listQueryRecord.current = 1;
      this.listQueryRecord.pushRecordState = null;
      this.listQueryRecord.pushBeginTime = null;
      this.listQueryRecord.pushEndTime = null;

      this.recordPageRequest();
    },
    searchClickRecord() {
      //弹窗集合服务搜索
      this.listQueryRecord.size = 10;
      this.listQueryRecord.current = 1;
      this.recordPageRequest();
    },
    handleSizeChangeRecord(val) {
      //添加集合分页
      this.listQueryRecord.size = val;
      this.listQueryRecord.current = 1;
      this.recordPageRequest();
    },
    handleCurrentChangeRecord(val) {
      //添加集合分页
      this.listQueryRecord.current = val;
      this.recordPageRequest();
    },
    sendingRecordClick(id) {
      //发送记录
      this.listQueryRecord.pushRuleId = id;
      // this.listQueryRecord.pushRuleId = "1682332661494939648";
      this.recordPageRequest();
      this.recordCountRequest();
      this.showAddQuestionRecord = true;
    },
    tableDataTemplateRequest() {
      //请求消息事件的接口
      console.log("11");
      pageOperateList(this.listQueryTemplate).then(res => {
        console.log('12');
        console.log(res,'resss');
        if (res.code == 0) {
          if (res.data) {
            if (res.data.records && res.data.records.length > 0) {
              let records = res.data.records;
              records.forEach((item, index) => {
                item.flag = true;
                this.selectList.forEach((el, i) => {
                  if (item.id == el.id) {
                    item.flag = false;
                  }
                });
              });
              console.log(records,'records');
              this.tableDataTemplate = records;
              this.totalTemplate = res.data.total;
            } else {
              this.tableDataTemplate = [];
              this.totalTemplate = 0;
            }
          } else {
            this.tableDataTemplate = [];
            this.totalTemplate = 0;
          }
        }
      });
    },
    tableDataShopRequest() {
      //请求消息事件的接口
      // let records = [{ name: "aaaaa", id: 1, flag: true }];
      // records.forEach((item, index) => {
      //   item.flag = true;
      //   this.assembleList.forEach((el, i) => {
      //     if (item.id == el.id) {
      //       item.flag = false;
      //     }
      //   });
      // });
      // this.tableDataShop = records;

      pageUserList(this.listQueryShop).then(res => {
        if (res.code == 0) {
          if (res.data) {
            if (res.data.records && res.data.records.length > 0) {
              let records = res.data.records.map((item, index) => {
                return {
                  ...item,
                  index: index + 1
                };
              });
              records.forEach((item, index) => {
                item.flag = true;
                this.assembleList.forEach((el, i) => {
                  if (item.id == el.id) {
                    item.flag = false;
                  }
                });
              });
              this.tableDataShop = records;
              this.totalShop = res.data.total;
            } else {
              this.tableDataShop = [];
              this.totalShop = 0;
            }
          } else {
            this.tableDataShop = [];
            this.totalShop = 0;
          }
        }
      });
    },
    operationalDetailRequest() {
      operationalDetail({
        id: this.id
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.formStepFirst.name = res.data.name;
            let obj = {
              msgEventName: res.data.eventName,
              id: res.data.eventId,
              msgEventCode:res.data.msgEventCode
            };
            // this.listQueryRecord.msgEventId = res.data.eventId
            this.formStepFirst.titleTemplate = res.data.eventName;
            this.selectList[0] = obj;
            this.formStepFirst.scope = res.data.targetUsersType;

            let objAssemble = {
              name: res.data.targetUsersSetName,
              // name: "bbbccc",
              id: res.data.targetUsersId,              
            };
            this.scopeName = res.data.targetUsersType;
            if (res.data.detailVos && res.data.detailVos.length > 0) {
              this.detailVosList = res.data.detailVos;
            }
            this.assembleList[0] = objAssemble;
            console.log(this.assembleList,'详情回来的');
            this.eventDetailRequest().then(resObj => {
              if (resObj.ruleList.length > 0) {
                if (res.data.detailVos && res.data.detailVos.length > 0) {
                  res.data.detailVos.forEach((item, index) => {
                    this.ruleList[index].templateParam = JSON.parse(
                      item.params
                    );
                    this.ruleList[index].resPushEventRuleId =
                      item.resPushEventRuleId;
                  });
                }
              }
            });
          }
        }
      });
    },
    recordPageRequest() {
      recordPage(this.listQueryRecord).then(res => {
        if (res.code == 0) {
          if (res.data) {
            if (res.data.records && res.data.records.length > 0) {
              this.tableDataRecord = res.data.records;
            } else {
              this.tableDataRecord = [];
            }
            this.totalRecord = res.data.total;
          } else {
            this.totalRecord = 0;
            this.tableDataRecord = [];
          }
        } else {
          this.totalRecord = 0;
          this.tableDataRecord = [];
        }
      });
    },
    groupListRequest() {
      //标签集合
      groupList(this.searchParamsGroup).then(res => {
        if (res.code == 0) {
          if (res.data && res.data.records) {
            let records = res.data.records.map((item, index) => {
              return {
                ...item,
                index: index + 1
              };
            });
            records.forEach((item, index) => {
              item.flag = true;
              this.assembleList.forEach((el, i) => {
                if (item.id == el.id) {
                  item.flag = false;
                }
              });
            });
            this.tableDataShopUser = records;
            this.totalShopUser = res.data && res.data.total;
          } else {
            this.tableDataShopUser = [];
            this.totalShopUser = 0;
          }
        } else {
          this.totalShopUser = 0;
          this.tableDataShopUser = [];
        }
      });
    },
    recordCountRequest(){//详细数据
      recordCount(this.listQueryRecord).then(res => {
        if(res.code == 0){
          if(res.data){
            this.countList = res.data
          }else{
            this.countList = []
          }
        }else{
          this.countList = []
        }
      }).catch(res => {
        this.countList = []
      })
    }
  }
};
</script>
  
<style lang="less" scoped>
@import "./operationalMessageAddEdit.less";
</style>
<style lang="less">
.popconfirmbox .el-popconfirm__main {
  align-items: flex-start !important;
  line-break: anywhere !important;
  margin: 0 0 10px 0 !important;
  letter-spacing: -1px;
}
.popconfirmbox .el-popconfirm__main .el-popconfirm__icon {
  margin-top: 3px;
}
</style>
  